module.exports = __webpack_public_path__ + "assets/example-right.499cc42c.svg";